import { useStore } from 'effector-react'
import { EditEmployee } from '~/features/Employees/EditEmployee'
import { viewerModel } from '~/entities/viewer'
import { Container, PageTitle, PageContainer } from '~/shared/ui/Layout'

function UserPersonalData() {
  const userId = useStore(viewerModel.$currentUserId)

  return (
    <PageContainer title='Персональные данные'>
      <Container isHeader>
        <PageTitle>Персональные данные</PageTitle>
      </Container>

      <EditEmployee employeeId={userId as UniqueId} canUpdate={false} />
    </PageContainer>
  )
}

export default UserPersonalData
